//@ts-ignore
import { tw } from "@careinfo/tailwind";
import Select, { SingleValue } from "react-select";
import makeAnimated from "react-select/animated";

const animatedComponents = makeAnimated();

type OptionType = {
  id: string;
  name: string;
};

type SelectFieldProps = {
  options: OptionType[];
  value?: OptionType | null;
  onChange?: (value: OptionType | null) => void;
  label?: string;
};

const SelectField = ({
  options,
  value,
  onChange,
  label = "Choose User Type",
}: SelectFieldProps) => {
  console.log(options, "option");
  return (
    <div className={tw`w-full`}>
      <span className={tw`mb-2 block`}>{label}</span>

      <Select<OptionType, false>
        components={animatedComponents}
        options={options}
        value={value}
        closeMenuOnSelect
        isClearable
        getOptionLabel={(option) => option.name}
        getOptionValue={(option) => option.id}
        onChange={(option: SingleValue<OptionType>) =>
          onChange?.(option ?? null)
        }
      />
    </div>
  );
};

export default SelectField;
